import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as  moment from "moment";
import { CRUDColumn } from '../../crud-dom/crud-column';
import { PipeTransform } from '@angular/core';
import { DynamicPipeInstantiator } from '@alfercom/common-pipes';
import { Filtro } from '../../filtri/filtri.type';
import { TranslateService } from '@ngx-translate/core';

export interface SpreadSheetCol {
  name: string;
  prop: string;
  pipe: any;
  color?: string;
  bold?: boolean;
  size?: boolean;
  groupedColumns?: CRUDColumn[];
  isGroupedColumn?: boolean;
}

export interface InitSpreadSheetExporter {
  rows?: any[];
  map?: { map: any; context?: any };
  filter?: { filter: any; context?: any };
  columns: any[];
  sheetName?: string;
  author?: string;
}

export interface WpContainerInterface {
  wb?: XLSX.WorkBook;
  ws?: XLSX.WorkSheet;
  wsFiltri?: XLSX.WorkSheet;
  wsIstruzioni?: XLSX.WorkSheet;
}

export class SpreadSheetsExporter {
  private rawRows: any[] = [];
  private rows: any[] = [];

  private map: any;
  private mapContext: any;
  private filter: any;
  private filterContext: any;

  private columns: SpreadSheetCol[] = [];

  // private sheetName: string = 'Dati Esportati ' + moment().format('DD-MM-YYYY');
  // private sheetFiltri: string = 'Filtri Applicati';
  // private fileName: string = 'export';
  // private addDateTimePrefix: boolean = false;
  // private title: string = 'Esportazione Effettuata tramite Piattaforma Rilancio Italia 2020 - www.rilancioitalia2020.it';


  private author: string = 'unknown';
  private fileNameDefault: string | undefined; //FEPB_CRUDXLSEXPORTER_FILENAMEDEFAULT: 'Esportazione effettuata in data';
  private title: string | undefined; //FEPB_CRUDXLSEXPORTER_TITLE: 'Esportazione Effettuata tramite Piattaforma Rilancio Italia 2020 - www.rilancioitalia2020.it';
  private filtriTitle: string | undefined; //FEPB_CRUDXLSEXPORTER_FILTERTITLE: 'FILTRI APPLICATI: '

  //'Dati Esportati ' + moment().format('DD-MM-YYYY');
  private sheetName: string | undefined; //FEPB_CRUDXLSEXPORTER_SHEETNAME: 'Dati Esportati '
  private sheetFiltri: string | undefined; //FEPB_CRUDXLSEXPORTER_SHEETFILTRI: 'Filtri Applicati'


  private exportType: 'xls' | 'xlsx' | 'csv' | 'txt' = 'xls';

  private filtriApplicati: Filtro[] = null;

  private wpContainer: WpContainerInterface = {};

  private columnCounter = 0;

  private translateServiceRef: TranslateService | undefined;
  private locale: string | undefined;

  parse() {
    let r = this.rawRows;
    if (this.filter) {
      r = this.rawRows.filter(this.filter, this.filterContext);
    }
    if (this.map) {
      r = this.rawRows.map(this.map, this.mapContext);
    }
    this.rows = r;
  }

  init(params: InitSpreadSheetExporter) {
    if (params.author) {
      this.author = params.author;
    }

    if (params.rows) {
      this.rawRows = [];
      this.rawRows = [...params.rows];
    }
    if (params.sheetName) {
      this.sheetName = params.sheetName;
    }
    if (params.columns) {
      this.columns = [];
      this.columns = [...params.columns];
    }
    if (params.map) {
      this.setMapFunction(params.map.map, params.map.context);
    }
    if (params.filter) {
      this.setFilterFunction(params.filter.filter, params.filter.context);
    }
  }

  setFiltriApplicati(filtri: Filtro[]) {
    this.filtriApplicati = [...filtri];
  }

  setMapFunction(map, context) {
    this.map = map;
    this.mapContext = context;
  }

  setFilterFunction(filter, context) {
    this.filter = filter;
    this.filterContext = context;
  }

  setRows(rows: any[]) {
    this.rawRows = [];
    this.rawRows = [...rows];
  }

  make() {
    this.wpContainer.wb = XLSX.utils.book_new();
    this.wpContainer.ws = {};
    this.makeHeader();
    this.makeBody();
    this.addProperties();
    this.calculateRange();
    XLSX.utils.book_append_sheet(this.wpContainer.wb, this.wpContainer.ws, this.sheetName);
    if (this.filtriApplicati && this.filtriApplicati.length > 0) {
      this.makeWsFiltri(this.filtriApplicati);
    }

    return this.wpContainer.wb;
  }

  makeWsFiltri(filtriApplicati: Filtro[]) {
    let end = 'A1';
    this.wpContainer.wsFiltri = {};
    this.wpContainer.wsFiltri['A1'] = {
      t: 's',
      v: this.filtriTitle // 'Elenco Filtri Applicati'
    };
    for (let i in filtriApplicati) {
      let cell = XLSX.utils.encode_cell({ r: +i + 1, c: 0 });
      end = cell;
      this.wpContainer.wsFiltri[cell] = {};
      this.wpContainer.wsFiltri[cell].t = 's';
      this.wpContainer.wsFiltri[cell].v = filtriApplicati[i].label;
    }
    this.wpContainer.wsFiltri['!ref'] = 'A1' + ':' + end;

    XLSX.utils.book_append_sheet(this.wpContainer.wb, this.wpContainer.wsFiltri, this.sheetFiltri);
  }

  addProperties() {
    if (!this.wpContainer.wb.Props) {
      this.wpContainer.wb.Props = {};
      this.wpContainer.wb.Props.Title = this.title;
      this.wpContainer.wb.Props.Author = this.author;
      this.wpContainer.wb.Props.CreatedDate = new Date();
    }
  }

  makeHeader() {
    let counter = 0;
    for (let i in this.columns) {
      let cell;
      if (this.columns[i].isGroupedColumn) {
        for (let el of this.columns[i].groupedColumns) {
          cell = XLSX.utils.encode_cell({ r: 0, c: +counter });
          this.wpContainer.ws[cell] = {};
          this.wpContainer.ws[cell].t = 's';
          this.wpContainer.ws[cell].v = this.columns[i].name + ' - ' + el.name;
          counter++;
        }
      } else {
        cell = XLSX.utils.encode_cell({ r: 0, c: +counter });
        this.wpContainer.ws[cell] = {};
        this.wpContainer.ws[cell].t = 's';
        this.wpContainer.ws[cell].v = this.translateServiceRef.instant(this.columns[i].name);
        counter++;
      }
      //this.wpContainer.ws[cell].w = this.columns[i].name;
    }
    this.columnCounter = counter;
    // this.wpContainer.ws = XLSX.utils.json_to_sheet(this.columns);
  }

  makeBody() {
    for (let i in this.rows) {
      let counter = 0;
      for (let c in this.columns) {
        let cell;
        if (this.columns[c].isGroupedColumn) {
          for (let el of this.columns[c].groupedColumns) {
            cell = XLSX.utils.encode_cell({ r: +i + 1, c: +counter });
            this.wpContainer.ws[cell] = {};
            let value = this.columns[c].pipe ?
              this.pipeValue(this.columns[c].pipe, this.rows[i][this.columns[c].prop][el.prop]) :
              //this.columns[c].pipe.transform(this.rows[i][this.columns[c].prop][el.prop]) :
              this.rows[i][this.columns[c].prop][el.prop];
            value = value == null || value == undefined ? '-' : value;
            this.wpContainer.ws[cell].v = value;
            this.wpContainer.ws[cell].t = isNaN(+value) ? 's' : 'n';
            counter++;
          }
        } else {
          cell = XLSX.utils.encode_cell({ r: +i + 1, c: +counter });
          this.wpContainer.ws[cell] = {};
          let value = this.columns[c].pipe ?
            this.pipeValue(this.columns[c].pipe, this.rows[i][this.columns[c].prop]) :
            //this.columns[c].pipe.transform(this.rows[i][this.columns[c].prop]) :
            this.rows[i][this.columns[c].prop];
          value = value == null || value == undefined ? '-' : value;
          this.wpContainer.ws[cell].v = value;
          this.wpContainer.ws[cell].t = isNaN(+value) ? 's' : 'n';
          counter++;
        }
      }
    }
  }

  pipeValue(pipeName, value) { //TODO DynamicPipeInstantiator
    const pipe: PipeTransform = pipeName && this.locale ? DynamicPipeInstantiator.getPipe(pipeName, [this.locale]) : null;
    if (pipe) {
      try {
        return pipe.transform(value);
      } catch (e) {
        return '-';
      }
    }
    return value;
  }

  calculateRange() {
    let start = XLSX.utils.encode_cell({ r: 0, c: 0 });
    let end = XLSX.utils.encode_cell({
      r: this.rows.length + 1,
      c: this.columnCounter
    });
    this.wpContainer.ws['!ref'] = start + ':' + end;
  }

  export(type: 'xls' | 'xlsx' | 'csv' | 'txt' = 'xlsx', fileName: string = this.fileNameDefault, rows: any[] = null) {
    if (rows) {
      this.setRows(rows);
      this.parse();
    }
    const wb = this.make();
    if (type == 'csv') {
      let result = XLSX.utils.sheet_to_csv(this.wpContainer.ws, { FS: ';' });
      var BOM = '\uFEFF';
      var csvData = BOM + result;
      var blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
      saveAs(blob, fileName + '.' + type);
    } else {
      XLSX.writeFile(wb, fileName + '.' + type);
    }
  }

  /**
   * 
   * @param translateService 
   * @param locale 
   */
  initMultiLang(translateService: TranslateService = undefined, locale: string = undefined) {
    this.translateServiceRef = translateService;
    this.locale = locale;
    this.getI18nCaptions();
  }

  /**
   * 
   */
  getI18nCaptions() {
    if (this.translateServiceRef) {
      this.sheetName = this.translateServiceRef.instant('FEPB_CRUDXLSEXPORTER_SHEETNAME');
      this.sheetFiltri = this.translateServiceRef.instant('FEPB_CRUDXLSEXPORTER_SHEETFILTRI');
      this.filtriTitle = this.translateServiceRef.instant('FEPB_CRUDXLSEXPORTER_FILTERTITLE');
      this.title = this.translateServiceRef.instant('FEPB_CRUDXLSEXPORTER_TITLE');
      this.fileNameDefault = this.translateServiceRef.instant('FEPB_CRUDXLSEXPORTER_FILENAMEDEFAULT');
    }
  }
}
